import { Stack } from '@chakra-ui/react';
import * as React from 'react';

import { GlobalSearch } from '@/components/GlobalSearch';
import { usePermissions } from '@/hooks/usePermissions';
import { AccountMenu } from '@/imports/ui/components/community-frame/AccountMenu';
import { CartNavLinkIconDisplay } from '@/imports/ui/components/community-frame/CartNavLinkIconDisplay';
import { ChatNavLinkIconDisplay } from '@/imports/ui/components/community-frame/chat-nav/ChatNavLinkIconDisplay';
import { InAppNotificationDropdown } from '@/imports/ui/notifications/components';
import { tokenStorage } from '@/modules/accounts/tokenStorage';
import { showChatIconInMobile } from '@/utilities';

/**
 * Tradewing header utilities shown beside Webflow navigation when logged in:
 * search, notifications, chat, cart, account avatar.
 */
export const WebflowNavUtilityCluster: React.FC = () => {
  const permissions = usePermissions();
  const showChatIcon = showChatIconInMobile();

  if (permissions.isLoading || !permissions.isAuthenticated) {
    return null;
  }

  if (tokenStorage.getItem('isMobile')) {
    return null;
  }

  return (
    <Stack direction="row" spacing="4" alignItems="center">
      {permissions.canAccessCommunityAndAuthenticated ? <GlobalSearch /> : null}
      <InAppNotificationDropdown />
      {permissions.canAccessDmPageAndAuthenticated && showChatIcon ? (
        <ChatNavLinkIconDisplay />
      ) : null}
      <CartNavLinkIconDisplay />
      <AccountMenu />
    </Stack>
  );
};
